import React from 'react';
import './References.css';
import AMC from './assets/amc.jpg';
import AOK from './assets/aok.jpg';
import BARMER from './assets/barmer.jpg';
import GLOBUS from './assets/globus.jpg';
import RAG from './assets/rag.jpg';
import THY from './assets/thy.jpg';
import TK from './assets/tk.jpg';
import VHS from './assets/vhs.jpg';
import DB from './assets/db.jpg';
import VB from './assets/vb.jpg';
import IKK from './assets/ikk.jpg';
import KNAPP from './assets/knappschaft.jpg';












const References = () => {
    return (
        <div className='References'>
            <div className="ReferencesWrapper">

                <a href="https://www.amc.info/de-de/">
                    <img className="AMC" src={AMC} alt="Test"></img>
                </a>



                <a href="https://www.globus.de">
                    <img className="GLOBUS" src={GLOBUS} alt="Test"></img>
                </a>

                <a href="https://www.aok.de">
                    <img className="AOK" src={AOK} alt="Test"></img>
                </a>



                <a href="https://www.barmer.de">
                    <img className="BARMER" src={BARMER} alt="Test"></img>
                </a>

                <a href="https://www.db.de">
                    <img className="DB" src={DB} alt="Test"></img>
                </a>
                <a href="https://www.rag.de">
                    <img className="RAG" src={RAG} alt="Test"></img>
                </a>
                <a href="https://www.thyssenkrupp.com">
                    <img className="THY" src={THY} alt="Test"></img>
                </a>

                <a href="https://www.tk.de">
                    <img className="TK" src={TK} alt="Test"></img>
                </a>

                <a href="https://www.volkshochschule.de">
                    <img className="VHS" src={VHS} alt="Test"></img>
                </a>

                <a href="https://www.villeroy-boch.de">
                    <img className="VB" src={VB} alt="Test"></img>
                </a>

                <a href="https://www.ikk.de">
                    <img className="IKK" src={IKK} alt="Test"></img>
                </a>

                <a href="https://www.knappschaft.de">
                    <img className="KNAPP" src={KNAPP} alt="Test"></img>
                </a>

            </div >
        </div>);

}



export default References;